<template>
  <div class="home">
    <el-row>
      <el-col :span="24" class="home-header">
        <div v-show="!logined" style="text-align: right; margin-top: 20px;">
          <el-button class="home-loginBtn" type="primary" icon="el-icon-s-custom" @click="toLogin" plain> 登录 </el-button>
        </div>
        <div v-show="logined" style="text-align: right; margin-top: 20px;">
            <span class="home-accountStatus"> {{ accountStatus }}</span>
            <el-dropdown trigger="click" @command="handleCommand">
              <el-button class= "home-accountBtn" icon="el-icon-s-custom" circle></el-button>
              <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-user" command="info">账号信息</el-dropdown-item>
              <el-dropdown-item icon="el-icon-link" command="share">推荐奖励</el-dropdown-item>
              <el-dropdown-item icon="el-icon-coin" command="pay">续期</el-dropdown-item>
              <el-dropdown-item icon="el-icon-thumb" command="help">获得帮助</el-dropdown-item>
              <el-dropdown-item icon="el-icon-guide" command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        <div class="home-topBar">
          <div class="home-title"><span style="text-align: center; font-weight:bold; font-size: 40px;">{{ title }}</span>
          </div>
        </div>
        <div class="home-searchBar">
          <el-input v-model="searchInput" placeholder="请输入搜索内容" clearable maxlength="200" @keyup.enter.native="toSearch">
            <el-button slot="append" icon="el-icon-search" circle @click="toSearch"></el-button>
          </el-input>
        </div>
      </el-col>
      <el-dialog title="推荐奖励" :visible.sync="shareDialogVisible" center>
        <div>将题库巴巴{{ address }}推荐给朋友注册并且朋友绑定学习账号成功后，您将获得三天使用时间</div>
        <div style="margin-top: 20px">步骤说明</div>
        <div>1.被推荐人注册时在推荐栏填入您的手机号</div>
        <div>2.被推荐人的账号信息需绑定学习账号</div>
        <span slot="footer" class="dialog-footer">
          <el-button v-clipboard:copy="address" v-clipboard:success="onAddressCopy" v-clipboard:error="onAddressError">复制网址</el-button>
          <el-button type="primary" @click="shareDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
      <el-dialog title="获得帮助" :visible.sync="centerDialogVisible" center>
        <div style="margin: auto; display:block; text-align: center;">添加微信:{{ weixin }} 获取更多帮助</div>
        <div style="margin: auto; display:block; width: 100px; height: 100px"><qriously :value="wechatUrl" :size="100" /></div>
        <span slot="footer" class="dialog-footer">
          <el-button v-clipboard:copy="weixin" v-clipboard:success="onCopy" v-clipboard:error="onError">复制微信号</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </el-row>
    <div class="qrcode">
        <el-button style="width: 90px; height: 30px" size=mini round v-clipboard:copy="qrweixin" v-clipboard:success="onCopy" v-clipboard:error="onError">复制微信号</el-button>
        <div style="font-size:16px; font-weight: bold; color: #FFF">{{ qrweixin }}</div>
        <div style="font-size:16px; font-weight: bold; color: #FFF">快速网课</div>
        <el-image style="width: 90px; height: 90px"
        :src="require('../assets/qrcode.png')"
        fit="fill"></el-image>
      </div>
    <div class="bottom"><a href="https://beian.miit.gov.cn/">苏ICP备18000128号</a></div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      title: '题库巴巴',
      searchInput: '',
      accountStatus: '已登录',
      centerDialogVisible: false,
      shareDialogVisible: false,
      wechatUrl: 'https://u.wechat.com/MPHM-QrR7wcCb2NOKBipTns',
      weixin: 'crystalgogo',
      qrweixin: 'yywlxy00',
      address: 'www.tiku88.com'
    }
  },
  metaInfo () {
    return {
      title: this.title + ' 云端学习 课后测试 题库 答案 择优网校 金融之家',
      meta: [
        {name: 'description', content: '题库巴巴拥有海量题库，题库日常每天云端更新，更有海量第一手的网课答案资源，是一款非常适合金融银行农信社人员在线学习考试的题库答案助手，参加金融考试推荐网站超星云课堂，云端学习，择优网校，金融之家等。'},
        {name: 'keywords', content: '题库巴巴,tiku88,超星云课堂,云端学习,择优网校,金融之家,超星云课堂,云端学习题库,题库,课后测试,云端,答案'}
      ]
    }
  },
  computed: {
    logined: function () {
      return this.$store.getters.isLogin
    }
  },
  created: function () {
    this.$axios.get('/login/syncUserStatus').then(res => {
      if (res.data['status'] === 200) {
        let status = res.data['data']
        if (status === 'NOTLOGIN') {
          this.$store.dispatch('setLogin', 'false')
        } else {
          this.$store.dispatch('setLogin', 'true')
        }
      }
    }).catch(e => {})
  },
  methods: {
    toLogin: function () {
      this.$router.push({path: '/login'})
    },
    toSearch: function () {
      // 检查输入框内容长度
      let searchContent = this.$data.searchInput
      if (searchContent.length === 0) {
        this.$data.highlightText = ''
        this.$message('搜索内容不能为空')
        return false
      }
      // 跳转到搜索页搜索
      this.$router.push({path: '/searchAnswer/search', query: {q: searchContent}})
    },
    onCopy (e) {
      this.$message({
        message: '复制成功，请打开微信添加!',
        type: 'success'
      })
    },
    onAddressCopy (e) {
      this.$message({
        message: '网址复制成功，请直接粘贴给朋友!',
        type: 'success'
      })
    },
    onError (e) {
      this.$message.error('复制失败，请手动添加微信！')
    },
    onAddressError (e) {
      this.$message.error('复制失败！')
    },
    handleCommand: function (command) {
      switch (command) {
        case 'info':
          this.$router.push({name: 'user'})
          break
        case 'share':
          this.$data.shareDialogVisible = true
          break
        case 'pay':
          this.$router.push({name: 'pay'})
          break
        case 'help':
          this.$data.centerDialogVisible = true
          break
        case 'logout':
          this.$axios.post('/login/logout').then(res => {
            if (res.data['status'] === 200) {
              this.$message({
                message: '已退出登录！',
                type: 'success'
              })
              this.$store.dispatch('setLogin', 'false')
            }
          }).catch(e => { this.$message.error('退出登录失败!') })
          break
      }
    }
  }
}

</script>

<style>

  .home {
    width: 100%;
    height: 100%;
    background-color: #409EFF;
  }

  .home-header {
    background-color: #409EFF;
    padding-left: 30px;
    padding-right: 30px;
    width: 100%;
    bottom: 30px;
  }

  .home-topBar {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    flex-flow: row;
    justify-content: space-between;
    margin-top: 150px;
  }

  .home-topBar .home-title {
    color: #FFF;
    font-size: 36px;
    margin:0 auto;
    text-align: center;
    display: block;
  }

  .home-searchBar {
    max-width: 600px;
    text-align: center;
    margin:0 auto;
    margin-top: 50px;
  }

  .home-loginBtn {
    height: 40px;
    display: float;
  }

  .home-accountStatus {
    color: #FFF;
    font-size: 18px;
  }

  .qrcode {
    position:fixed;
    bottom:0px;
    right:0px;
    width: 120px;
    height: 180px;
    text-align: center;
  }

  .bottom {
    position:fixed;
    bottom: 5px;
    width: 100%;
    text-align: center;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue